import { useRef } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import useLocalStorageCards from 'Deer/hooks/useLocalStorageCards';
import { setIsCardOpen } from 'Deer/slice/DeerCollapsibleCard.slice';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getUniqueCardKey } from 'utils/helpers/getUniqueCardKey';

import { sendExpandedChartEvent } from 'constants/mixpanelHelper';

import { ExpandableContainerProvider } from 'uiToolkitV1/ExpandableContainerProvider';

import { CandidateProgressTable } from './CandidateProgressTable';
import { LifecycleMeshRecommends } from './components/LifecycleMeshRecommends';
import { LifecycleOverviewSection } from './components/LifecycleOverviewSection';
import { LifecycleProgressChart } from './components/LifecycleProgressChart';
import { MESH_RECOMMENDATIONS_PROGRESS } from './constants';

export const LifecycleProgressIntent = () => {
  const gridRef = useRef();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentURL = location.pathname;
  const localStorageKey = getUniqueCardKey({ url: currentURL, cardId: 'lifecycleInsightsProgress' });
  const isCardOpen = useLocalStorageCards({
    localStorageKey,
    card: 'lifecycleInsightsProgress',
    section: 'myCompany',
  });
  const handleChange = (newVal: boolean) => {
    dispatch(
      setIsCardOpen({
        card: 'lifecycleInsightsProgress',
        section: 'myCompany',
        isCardOpen: newVal,
        localStorageKey,
      })
    );
    return newVal;
  };
  return (
    <>
      <LifecycleOverviewSection open={isCardOpen} onOpenChange={handleChange} title="Overview">
        <Flex
          borderRadius="8px"
          p={2}
          width="full"
          minHeight="full"
          flexDirection={{ base: 'column', md: 'row' }}
          gap="8px"
        >
          <Flex width="100%">
            <LifecycleMeshRecommends points={MESH_RECOMMENDATIONS_PROGRESS} />
          </Flex>
        </Flex>
        <Flex gap="8px" bg="#FFF" w="100%" h="auto" borderRadius="8px" marginTop="8px">
          <Flex width="100%" bg="#F5F7F9" p={2} borderRadius="8px">
            <Box h="100%" w="100%" bg="white" borderRadius="8px">
              <ExpandableContainerProvider
                id="lifeCycleInsightsQuadrantsGraph"
                isParentDeterminesHeight
                toggleBtnBoxProps={{ top: '3px !important', zIndex: '99' }}
                onExpand={() => {
                  sendExpandedChartEvent({
                    eventProperties: {
                      source: 'lifecycle',
                      type: 'insights',
                    },
                  });
                }}
              >
                <LifecycleProgressChart title="" />
              </ExpandableContainerProvider>
            </Box>
          </Flex>
        </Flex>
      </LifecycleOverviewSection>
      <Box bg="#FFF" w="100%" h="auto" borderRadius="8px" p="12px" mt="10px">
        <CandidateProgressTable gridRef={gridRef} />
      </Box>
    </>
  );
};
